import { Box, Divider } from "@mui/material";

// Import components
import GstSettingsSection from "./GstSettingsSection";
import CustomerCareSection from "./CustomerCareSection";
import CompanyDetailsSection from "./CompanyDetailsSection";
import { IGeneralSettingsFormValues } from "@/utils/zod/generalSettingsFormValidation";
import { useList } from "@refinedev/core";

const GeneralSettings = () => {

  const {data: generalSettings} = useList<IGeneralSettingsFormValues>({
    resource: "general-settings",
    queryOptions: {
      queryKey: ["general-settings"],
      select: (data: any) => {
        const customerCarePhoneNumber = data.data.find((item: any) => item.key === "new_user_config")?.value.customer_care_phone_number || "";
        const parsedCustomerCarePhoneNumber = customerCarePhoneNumber.startsWith("+91") ? customerCarePhoneNumber.slice(3) : customerCarePhoneNumber;
        const transformedData: IGeneralSettingsFormValues = {
          gst_settings: data.data.find((item: any) => item.key === "gst_settings")?.value || [{
            gstRate: 0,
            priceUptoInclusive: null
          }],
          customer_care_phone_number: parsedCustomerCarePhoneNumber,
          company_details: data.data.find((item: any) => item.key === "company_details")?.value || {
            companyName: "",
            godName: "",
            gstin: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            website: "",
            logoUrl: "",
            phoneNumbers: [""]
          }
        };
        return { data: [transformedData], total: data.total };
      }
    }
  });

  return (
        <Box sx={{ p: 2 }}>
          {/* Company Details Section */}
          <CompanyDetailsSection values={generalSettings?.data[0].company_details ?? {}}/>
          <Divider sx={{ mt: 2, mb: 3 }} />

          {/* GST Settings Section */}
          <GstSettingsSection values={{gst_settings: generalSettings?.data[0].gst_settings ?? []}}/>
          <Divider sx={{ mt: 2, mb: 3 }} />

          {/* Customer Care Section */}
          <CustomerCareSection values={{customer_care_phone_number: generalSettings?.data[0].customer_care_phone_number ?? ""}}/>

        </Box>
  );
};

export default GeneralSettings;